import { snakeToCamel } from '~utils/string';

export const getQuantityByStatus = (status, quantityOrders) =>
  status.reduce((quantity, state) => quantity + (quantityOrders[snakeToCamel(state)] || 0), 0);
